import { CSSProperties } from "react";
import useScreen from "Hooks/useScreen";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import { makeKey } from "modules/Utils";
import ButtonSymphony, { ButtonVariant } from "./ButtonSymphony";
import Icon from "./Icon";

export const HEADER_ELEMENT_HEIGHT = 64;

const navigationItems = [
    {
        name: 'Product',
        href: 'https://www.symphonyos.co/product'
    },
    {
        name: 'About Us',
        href: 'https://www.symphonyos.co/about'
    },
    {
        name: 'Case Studies',
        href: 'https://www.symphonyos.co/case-studies'
    }
];

const Header = () => {
    const {
        mobileView,
        mStyle
    } = useScreen();

    const accountItems: {
        name: string;
        href?: string;
        variant: ButtonVariant;
        isPrimary?: boolean;
        onClick?: () => void;
    }[] = [
            {
                name: 'Log In',
                href: '/?t=login',
                variant: 'outlined'
            },
            {
                name: 'Get Started',
                isPrimary: true,
                variant: 'primary',
                onClick: () => {
                    const inputBox = document.getElementById('inputBox');
                    if (inputBox) {
                        inputBox.focus();
                    }
                }
            }
        ];

    return (
        <div
            className="headerElement"
            style={mStyle(sty, 'headerElement')}
        >
            <div className="headerInner" style={mStyle(sty, 'headerInner')}>
                <div className="headerLogoContainer">
                    <Icon
                        className="headerLogoIcon"
                        icon="sLogoPurple"
                        size={mobileView ? 28 : 36}
                    />
                </div>

                <div
                    className="headerNavigation"
                    style={mStyle(sty, 'headerNavigation')}
                >
                    {!mobileView && navigationItems.map((item, index) => (
                        <ButtonSymphony
                            key={`nav-${index}`}
                            className="headerButton"
                            style={sty.headerButton}
                            variant="text"
                            color="black"
                            onClick={() => window.open(item.href, '_blank')}
                            size={mobileView ? 'small' : 'medium'}
                        >
                            {item.name}
                        </ButtonSymphony>
                    ))}
                </div>

                <div
                    className="headerAccount"
                    style={sty.headerAccount}
                >
                    {accountItems.map((item, index) => (
                        <ButtonSymphony
                            key={makeKey('account', index)}
                            className="headerButton"
                            style={sty.headerButton}
                            variant={item.variant}
                            onClick={() => {
                                if (item.href) {
                                    window.open(item.href, '_blank')
                                } else {
                                    item.onClick?.()
                                }
                            }}
                            size={mobileView ? 'small' : 'medium'}
                        >
                            {item.name}
                        </ButtonSymphony>
                    ))}
                </div>
            </div>
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    headerElement: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingTop: 24,
        paddingBottom: 0,
        paddingLeft: 24,
        paddingRight: 24,
        flexShrink: 0,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 999
    },
    headerElement_mobile: {
        padding: 18,
        paddingBottom: 0,
    },
    headerInner: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: Colors.white,
        height: HEADER_ELEMENT_HEIGHT,
        borderRadius: 1000,
        color: Colors.black,
        maxWidth: 1200,
        marginLeft: 'auto',
        marginRight: 'auto',
        boxShadow: Sty.boxShadow,
        paddingLeft: 16,
        paddingRight: 16
    },
    headerInner_mobile: {
        height: 48,
    },
    headerLogo: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center'
    },
    logoText: {
        fontSize: 24,
        fontWeight: 600,
        color: Colors.white,
        margin: 0
    },
    headerNavigation: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 32,
        flex: 1
    },
    headerNavigation_mobile: {
        gap: 16
    },
    headerAccount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
        justifyContent: 'flex-end'
    },
    headerButton: {
        fontSize: 16,
        fontWeight: 500
    },
    headerLogoContainer: {
        flex: 1,
        textAlign: 'left'
    }
};

export default Header;